import React from "react";
import tw from "tailwind-styled-components";
import { Images } from "../../Images";

const Header = ({ HeaderData }) => {

    return (
        <div className="bg-white px-4 py-2 xl:py-4 flex justify-between border-b border-gray-200 items-center">
            <div>
                <Heading>Hey, {HeaderData?.name}</Heading>
                <Subheading>Welcome to OxoStay</Subheading>
            </div>
            {/* <Logo src={Images.OxoStayLogo} /> */}
            <h1 className="text-[#07A5E2] font-bold text-xl ">OxoStay</h1>
        </div>
    );
};

const Heading = tw.div`md:text-sm text-[0.95rem] text-black font-bold`;
const Subheading = tw.div`md:text-sm text-[0.90rem] font-medium text-gray-500`;
const Logo = tw.img`h-10 w-10`;

export default Header;
